// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3OWDL","validationTips":"StatementDescriptor_validationTips__3CSsw"};